var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAccountDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2267.719 2267.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1650.834 586.258c0 245.039-230.664 443.634-515.211 443.634s-515.21-198.595-515.21-443.634c0-245 230.664-443.574 515.211-443.574s515.21 198.574 515.21 443.574zM1818.358 1190.709c-149.75-38.388-272.93-130.547-379.734-83.083-134.477 59.771-221.787 86.002-308.518 84.202v.48c-84.854.56-171.264-25.792-302.742-84.263-106.805-47.444-229.984 44.716-379.734 83.103-223.447 57.222-364.9 711.966-155.129 787.222 186.719 67.018 473.584 149.87 843.383 149.311v-.479c366.979-.28 651.865-82.573 837.584-149.231 209.79-75.296 68.357-730.001-155.11-787.262z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccountDefault);
export default __webpack_public_path__ + "static/media/ic_account_default.a9fb9ba42e8ad0d40494edfc45b5c070.svg";
export { ForwardRef as ReactComponent };